import { Component, Input, AfterViewInit } from '@angular/core';
import CustomStore from 'devextreme/data/custom_store';
import {ProductBarcodeService} from '../../../../api/product-barcode.service';


@Component({
	selector: 'app-barcode-detail-view',
	templateUrl: 'barcode-detail-view.component.html',
	providers: [],
})
export class BarcodeDetailViewComponent implements AfterViewInit {
	@Input() key: number;

	public processingStatusForBarcodeData: any = {};

	constructor(
		private productBarcodeService: ProductBarcodeService,
	) {
	}

	ngAfterViewInit() {
		this.processingStatusForBarcodeData = new CustomStore({
			key: 'BarcodeMappingProcessingStatusId',
			load: (loadOptions: any) => {
				return this.productBarcodeService.getProcessingStatusForBarcodeMappingResult(loadOptions, this.key)
					.toPromise()
					.then((data: any) => {
						return {
							data: data.data,
							totalCount: data.totalCount,
							summary: data.summary,
							groupCount: data.groupCount
						};
					})
					.catch(error => { throw new Error('Data Loading Error'); });
			}
		});
	}
}
